import { Button, TextInput } from '@wfp/react';
import isEmpty from 'lodash/isEmpty';
import type { FC } from 'react';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { msalApp } from 'src/auth/auth';
import { RootState } from 'src/redux/store';

interface ICustomLoginProps {
  customLogin: (username: string, password: string) => void;
}

const pswMinChars = 8;

const CustomLoginForm: FC<ICustomLoginProps> = ({ customLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [msLoggedAccounts, setMsLoggedAccounts] = useState(null);

  const customLoginData = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();

  const formError = password.length < pswMinChars;

  async function getLoggedAccounts() {
    const accounts = await msalApp.getAllAccounts();
    setMsLoggedAccounts(accounts);
  }

  function handleLogin() {
    customLogin(username, password);
  }

  useEffect(() => {
    getLoggedAccounts();
  }, []);

  // Redirect logged users to the Dashboard
  if (customLoginData?.accessToken || !isEmpty(msLoggedAccounts)) {
    navigate('/');
  }

  return (
    <div className="custom-login-wrapper">
      <div className="custom-login-form-wrapper">
        <TextInput
          type="text"
          onChange={e => setUsername(e.target.value)}
          value={username}
          labelText="Username"
          placeholder="Insert username"
        />
        <TextInput
          type="password"
          onChange={e => setPassword(e.target.value)}
          value={password}
          labelText="Password"
          placeholder="Insert password"
        />
        <Button onClick={handleLogin} kind="primary" disabled={formError}>
          Login
        </Button>
      </div>
    </div>
  );
};

export default CustomLoginForm;
